import React from 'react'
import PropTypes from 'prop-types'
import Datetime from 'react-datetime'
import Deductions from './Deductions.js'

const DueDate = props => {
  return (
    <div>
      <div className="form-check">
        <label className="form-check-label" htmlFor="dueDate">
          New Due Date:
          <Datetime
            inputProps={{
              className: '',
              id: 'DueDatePicker',
              name: 'dueDate',
              type: 'text',
            }}
            onChange={value => props.onDateChange(value.toDate())}
            value={props.dateValue}
            closeOnSelect
          />
        </label>
        <div className="form-group mt-3">
          <label htmlFor="lateActionDropdown">If the submission is late:</label>
          <select
            className="form-control"
            id="lateActionDropdown"
            value={props.lateAction}
            onChange={e => props.onLateRuleChange(e.target.value)}
          >
            <option value="flag">
              Flag it as late in the grader, but do not deduct any points
            </option>
            <option value="prevent">
              Prevent the submission; No late work will be accepted
            </option>
            <option value="deduct">
              Automatically deduct points, per the following rules
            </option>
          </select>
          <div
            className={`${props.lateAction === 'deduct' ? '' : 'd-none'} mt-3`}
          >
            <Deductions
              onChange={props.onDeductionsChange}
              deductions={props.deductions}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

DueDate.propTypes = {
  onDateChange: PropTypes.func,
  dateValue: PropTypes.object,
  onLateRuleChange: PropTypes.func,
  lateAction: PropTypes.oneOf(['flag', 'prevent', 'deduct']),
  onDeductionsChange: PropTypes.func,
  deductions: PropTypes.array,
}

export default DueDate
